export default __webpack_public_path__ + "static/media/christmasLogoSingle.fbd02acf.png";